/* Hero slider init for every .sah-hero instance (lazy, non-blocking) */
(function () {
  const rqIdle =
    window.requestIdleCallback ||
    function (cb) {
      return setTimeout(cb, 1);
    };

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyDotColors(root, paginationEl) {
    if (!root || !paginationEl) return;

    const useColored = root.dataset.coloredDotsMobile === 'true';
    if (!useColored) return;

    const perSlide = root.dataset.dotsUsePerSlideColor === 'true';
    const inactiveOpacity = parseFloat(
      root.dataset.dotsInactiveOpacity || '0.6'
    );
    const activeScale = parseFloat(root.dataset.dotsActiveScale || '1.4');

    const bullets = paginationEl.querySelectorAll(
      '.swiper-pagination-bullet'
    );
    const slides = root.querySelectorAll('.swiper-slide');

    bullets.forEach(function (bullet, index) {
      const cssDotColor =
        getComputedStyle(root).getPropertyValue('--dot-active').trim() ||
        '#29ABE2';

      const color =
        perSlide && slides[index]
          ? slides[index].getAttribute('data-dot') || '#29ABE2'
          : cssDotColor;

      bullet.style.background = color;
      bullet.style.opacity = inactiveOpacity;
      bullet.style.transform = 'scale(1)';
    });

    const active = paginationEl.querySelector(
      '.swiper-pagination-bullet-active'
    );

    if (active) {
      active.style.opacity = '1';
      active.style.transform = 'scale(' + activeScale + ')';
    }
  }

  function initOne(root) {
    if (!root || root.dataset.initialized === '1') return;
    if (!window.Swiper) return; // Swiper must be loaded by theme

    const sliderEl = root.querySelector('.home-slider');
    const paginationEl = root.querySelector('.swiper-pagination');

    /*
     * Some service/content sections also use .sah-hero but are not Swiper
     * sliders. Exit safely instead of trying to access null elements.
     */
    if (!sliderEl || !paginationEl) return;

    const prevBtn = root.querySelector('.swiper-nav.prev');
    const nextBtn = root.querySelector('.swiper-nav.next');

    const autoplayEnabled =
      root.dataset.autoplay === 'true' && !prefersReduced;

    const intervalSeconds = parseInt(root.dataset.interval || '6', 10);
    const delay =
      (Number.isFinite(intervalSeconds) ? intervalSeconds : 6) * 1000;

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      spaceBetween: 0,
      loop: root.dataset.loop === 'true',
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      // RTL is handled by CSS dir; Swiper is layout-agnostic in fade mode.
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn
            }
          : undefined,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      a11y: { enabled: true },
      autoplay: autoplayEnabled
        ? {
            delay: delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false
    });

    const recolor = function () {
      applyDotColors(root, paginationEl);
    };

    swiper.on('init', recolor);
    swiper.on('slideChange', recolor);

    // Covers Swiper versions where init may have fired during construction.
    setTimeout(recolor, 0);

    document.addEventListener(
      'visibilitychange',
      function () {
        if (!swiper.autoplay) return;

        if (document.hidden) {
          if (typeof swiper.autoplay.stop === 'function') {
            swiper.autoplay.stop();
          }
        } else if (typeof swiper.autoplay.start === 'function') {
          swiper.autoplay.start();
        }
      },
      { passive: true }
    );

    root.dataset.initialized = '1';
  }

  function lazyInit(root) {
    if (!root) return;

    const sliderEl = root.querySelector('.home-slider');

    /*
     * .sah-hero is also used by non-slider sections.
     * Do not initialise those sections as Swiper instances.
     */
    if (!sliderEl) return;

    if (!('IntersectionObserver' in window)) {
      rqIdle(function () {
        initOne(root);
      });
      return;
    }

    let started = false;

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.25 &&
            !started
          ) {
            started = true;
            io.disconnect();

            rqIdle(function () {
              initOne(root);
            });
          }
        });
      },
      { threshold: [0, 0.25, 0.5] }
    );

    io.observe(sliderEl);
  }

  function boot() {
    document.querySelectorAll('.sah-hero').forEach(lazyInit);
  }

  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    /*
     * BFCache restore: only recolour real sliders that actually have
     * pagination. This prevents:
     * "Cannot read properties of null (reading 'classList')"
     */
    document.querySelectorAll('.sah-hero').forEach(function (root) {
      const paginationEl = root.querySelector('.swiper-pagination');
      if (!paginationEl) return;

      rqIdle(function () {
        applyDotColors(root, paginationEl);
      });
    });
  });
})();
